import type React from 'react';

export function AdversarialBadge(): React.JSX.Element {
  return (
    <span className="adv-badge" title="Bond adversarial">
      <span aria-hidden="true">⚖</span> adversarial
    </span>
  );
}
